import Config from 'common/config';
import { PrefixUrl } from 'common/constants/prefix-url';
import { CredentialCookieStorage } from 'components/common/credential-cookie-storage';
import { getLanguage } from 'components/common/language-storage';
import ky, { Options } from 'ky';

export const defaultUrl = Config.apiEndpoint + '/api/employee';

const config: Options = {
  retry: {
    limit: 2,
    methods: ['get', 'post', 'put', 'delete', 'patch'],
    statusCodes: [401],
  },
  prefixUrl: defaultUrl.includes('staging') ? PrefixUrl.get() : defaultUrl,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
  },
  hooks: {
    beforeRequest: [
      (request) => {
        const token = CredentialCookieStorage.get('access-token');
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        } else {
          request.headers.delete('Authorization');
        }
        const language = getLanguage();
        request.headers.set('Accept-Language', language ?? 'en');
      },
    ],
    afterResponse: [
      async (_request, _options, res) => {
        const contentType = res.headers.get('content-type');
        let newResponse = res.clone();
        if (contentType && contentType.includes('application/json')) {
          const json = await res.json();
          const { status, statusText, headers } = res;
          newResponse = new Response(JSON.stringify(json), {
            status,
            statusText,
            headers,
          });
        }

        if (
          contentType &&
          (contentType.includes('application/pdf') ||
            contentType.includes(
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ))
        ) {
          const { status, statusText, headers } = res;
          const blob = await res.blob();

          newResponse = new Response(blob, {
            status,
            statusText,
            headers,
          });
        }

        return newResponse;
      },
    ],
    beforeRetry: [
      ({ request, options, error, retryCount }) => {
        request.headers.set('x-retry', retryCount.toString());
      },
    ],
  },
};

export const client = ky.create(config);
